// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/css/async/" + "__federation_expose_UPPSearch" + "." + "227691e2" + ".css"
}